import { SentryConfig as SentryConfigInterface } from '@lopo-tech/lopo-config/interfaces'

export const SentryConfig: SentryConfigInterface = {
  dsn: 'https://bd196df9acae13cfc026a2b1ec5ee3b6@beeftraeger.mvp-lab.de/11',
  project: 'web',
  org: 'lopo',
  url: 'https://beeftraeger.mvp-lab.de'
}
